export const userRole = {
  ADMIN: 1,
  SUBADMIN: 2,
  USER: 3,
  VENDOR: 4,
  FACTORY: 5,
  DISPATCHER: 6,
  DRIVER: 7,
  ALL: 8,
  SALES_MANAGER: 10,
  EMPLOYEE: 11
};
